import {Component, OnInit, ViewChild} from '@angular/core';
import {TestimonialModel} from '../../../../models/testimonial-model';
import {NgbCarousel, NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from "../../../../services/api.service";

@Component({
    selector: 'app-testimonials-section',
    templateUrl: './testimonials-section.component.html',
    styleUrls: ['./testimonials-section.component.scss'],
    providers: [NgbCarouselConfig],
})
export class TestimonialsSectionComponent implements OnInit {

    @ViewChild('carousel', {static: true}) carousel!: NgbCarousel;
    public testimonials: TestimonialModel[] = [];
    private touchStartX = 0;
    private touchEndX = 0;

    constructor(private apiService: ApiService,
                private config: NgbCarouselConfig) {
        config.showNavigationIndicators = false;
        config.showNavigationArrows = false;
    }

    ngOnInit(): void {
        this.apiService.getTestimonials().then(data => {
            this.testimonials = data;
        });
    }

    onImageError(event: any, index: number): void {
        // Hide the image element when it fails to load
        event.target.style.display = 'none';
        // Optionally, you could also update the testimonial data to remove the image
        if (this.testimonials && this.testimonials[index]) {
            this.testimonials[index].image = null;
        }
    }

    onTouchStart(event: TouchEvent) {
        this.touchStartX = event.changedTouches[0].screenX;
        this.carousel.pause();
    }

    onTouchEnd(event: TouchEvent) {
        this.touchEndX = event.changedTouches[0].screenX;
        this.handleSwipe();
        this.carousel.cycle();
    }

    private handleSwipe() {
        if (this.testimonials.length === 0) return;
        if (this.touchEndX < this.touchStartX - 50)
            this.carousel.next();
        if (this.touchEndX > this.touchStartX + 50)
            this.carousel.prev();
    }
}
